import React from 'react'
import reactStamp from 'react-stamp'
import {Table} from 'reactable'
import RaisedButton from 'material-ui/RaisedButton';
import UpcomingAppointmentsTable from './UpcomingAppointmentsTable'
import AppointmentsHistoryTable from './AppointmentsHistoryTable'
import './appointments.css'

export default reactStamp(React).compose({

    init(){
        this.handleBookClick = this.handleBookClick.bind(this);
    },

    render() {

        let headClassName = "";
        if (!this.props.single) {
            headClassName = "head";
        }

        const styles = {
            button: {
                marginLeft: "auto",
                height: 37,
            }
        };
        
        return (
            <div className="history-container">

                <div className={headClassName}>
                    <h1 className="appointments-title">My Appointments</h1>
                    <RaisedButton
                        label="Book Appointment"
                        primary={true}
                        style={styles.button}
                        onTouchTap={this.handleBookClick}
                    />
                </div>

                <UpcomingAppointmentsTable upcomingAppointments={this.props.upcomingAppointments}/>
                <AppointmentsHistoryTable appointmentsHistory={this.props.appointmentsHistory}/>
            </div>
        )

    },

    handleBookClick(){
        this.props.activateBooking();
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Appointments/AppointmentsHistory.js
 **/